export const formatNumber = (num, decimals = 2) => {
  if (num === null || num === undefined || isNaN(num)) return "N/A";
  
  return num.toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export const formatDuration = (hours) => {
  if (!hours || isNaN(hours)) return "N/A";

  const days = Math.floor(hours / 24);
  const remainingHours = Math.floor(hours % 24);
  const minutes = Math.floor((hours % 1) * 60);

  if (days > 0) {
    return `${days}d ${remainingHours}h ${minutes}m`;
  } else if (remainingHours > 0) {
    return `${remainingHours}h ${minutes}m`;
  } else {
    return `${minutes}m`;
  }
};

export const getOrbitTypeName = (altitude) => {
  if (altitude < 2000) return "LEO";
  if (altitude < 35786) return "MEO";
  if (Math.abs(altitude - 35786) < 100) return "GEO";
  return "HEO";
};

export const getOrbitColor = (altitude) => {
  if (altitude < 2000) return "#10b981"; // green
  if (altitude < 35786) return "#f59e0b"; // amber
  if (Math.abs(altitude - 35786) < 100) return "#ef4444"; // red
  return "#8b5cf6"; // purple
};